module.exports = __webpack_public_path__ + "static/media/rose.8c4d799d.png";